import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import SelfReflectionInteractiveFlow from "@/components/storyboard/selfreflection/SelfReflectionInteractiveFlow";
import { QuizValidationService } from "@/services/QuizValidationService";
import { storyboardTitle } from "@/lib/storyboardTitle";
import type {
  TextExperienceReflectionData,
  TextSelfReflectionQuestionsData,
} from "@/types/storyboard";

interface Props {
  data: TextExperienceReflectionData | string;
  contentElementId: string;
  title: string;
}

const EXPERIENCE_REFLECTION_LABELS = {
  startCta: "Mit der Erfahrungsreflexion starten",
  continueCta: "Mit der Erfahrungsreflexion weitermachen",
  completedText: "Du hast diese Erfahrungsreflexion abgeschlossen.",
};

export const TextExperienceReflection = ({
  data,
  contentElementId,
  title,
}: Props) => {
  if (typeof data === "string") {
    return (
      <div className="rounded-2xl bg-accent px-5 py-6">
        <div className="prose max-w-full text-base">
          <CourseMarkdown>{data}</CourseMarkdown>
        </div>
      </div>
    );
  }

  const heading = storyboardTitle(data.title, title);
  const reflectionData: TextSelfReflectionQuestionsData = {
    title: heading,
    introduction: data.instruction,
    questions: [{ text: data.question }],
  };

  return (
    <SelfReflectionInteractiveFlow
      id={contentElementId}
      title={heading || "Erfahrungsreflexion"}
      data={reflectionData}
      illustrationKind="experience_reflection"
      labels={EXPERIENCE_REFLECTION_LABELS}
      onValidate={(answer, index) =>
        QuizValidationService.validateAnswer({
          type: "experience_reflection",
          userInput: answer,
          contentElementId,
          entryIndex: index,
        })
      }
    />
  );
};
